import * as React from 'react';
import styled from 'styled-components';
import MuiRadio, { RadioProps as MuiRadioProps } from '@material-ui/core/Radio';

const StyledRadio = styled(MuiRadio)``;

export type DSRadioProps = Omit<MuiRadioProps, 'component'>;
export const DSRadio: React.FC<DSRadioProps> = StyledRadio;
DSRadio.displayName = 'DSRadio';
